export interface FilterOperator {
  value: string
  label: string
}

export interface FilterField {
  column: string
  label: string
  type: 'String' | 'Number' | 'Boolean' | 'Datetime'
  url?: string
  isDate?: boolean
}

const filterOperators: FilterOperator[] = [
  { value: 'is', label: 'Is' },
  { value: '=', label: 'Equals' },
  { value: '!=', label: 'Not equals' },
  { value: '~', label: 'Contains' },
  { value: '!~', label: 'Not contains' },
  { value: '>', label: 'Greater than' },
  { value: '<', label: 'Less than' },
  { value: '>=', label: 'Greater or equal' },
  { value: '<=', label: 'Less or equal' },
]

export const autoCompleteOperators: string[] = ['=', '!=']

export const getOperatorsForType = (
  type: 'String' | 'Number' | 'Boolean' | 'Datetime'
): FilterOperator[] => {
  switch (type) {
    case 'String':
      return [
        { value: '=', label: 'Equals' },
        { value: '!=', label: 'Not equals' },
        { value: '~', label: 'Contains' },
        { value: '!~', label: 'Not contains' },
      ]
    case 'Number':
      return [
        { value: '=', label: 'Equals' },
        { value: '!=', label: 'Not equals' },
        { value: '>', label: 'Greater than' },
        { value: '<', label: 'Less than' },
        { value: '>=', label: 'Greater or equal' },
        { value: '<=', label: 'Less or equal' },
      ]
    case 'Boolean':
      return [
        { value: 'is', label: 'Is' },
        { value: '=', label: 'Equals' },
      ]
    case 'Datetime':
      return [
        { value: '=', label: 'Equals' },
        { value: '!=', label: 'Not equals' },
        { value: '>', label: 'After' },
        { value: '<', label: 'Before' },
        { value: '>=', label: 'After or equal' },
        { value: '<=', label: 'Before or equal' },
      ]
    default:
      return filterOperators
  }
}
export const filterFieldsMapper = {
  bookingID: 'l_booking_id',
  eventCategoryName: 'listing_category_name',
  eventName: 'listing_event_name',
  eventDate: 'l_event_date',
  eventGroupName: 'listing_event_group_name',
  platformOrderID: 'order_id',
  salesPlatformName: 'platform_name',
}

export const filterFields: FilterField[] = [
  { column: filterFieldsMapper.bookingID, label: 'Booking ID', type: 'String' },
  {
    column: filterFieldsMapper.eventCategoryName,
    label: 'Event Category Name',
    type: 'String',
    url: '/api/events/categories/distinct',
  },
  {
    column: filterFieldsMapper.eventName,
    label: 'Event Name',
    type: 'String',
    url: '/api/events/distinct',
  },
  { column: filterFieldsMapper.eventDate, label: 'Event Date', type: 'Datetime', isDate: true },
  {
    column: filterFieldsMapper.eventGroupName,
    label: 'Event Group Name',
    type: 'String',
    url: '/api/events/event-groups/distinct',
  },
  { column: filterFieldsMapper.platformOrderID, label: 'Platform Order ID', type: 'String' },
  {
    column: filterFieldsMapper.salesPlatformName,
    label: 'Sales Platform Name',
    type: 'String',
    url: '/api/bookings/sales-platforms/distinct',
  },
]
